import React from "react";
import {
  Build,
  Palette,
  DesignServices,
  ContentCut,
  Checkroom,
  EmojiObjects,
  Verified,
  Label,
  Iron,
  Inventory,
  Warehouse,
  Work,
} from "@mui/icons-material";
import SvgIcon from "@mui/material/SvgIcon";

// Custom SVG Icon for Textile
const TextileIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
  </SvgIcon>
);

const coreValues = [
  "Customer-Centric Approach: We put our customers first and always strive to exceed their expectations.",
  "Excellence in Quality: We are committed to providing high-quality products with careful attention to every detail.",
  "Innovation and Creativity: We embrace new ideas and constantly innovate to stay ahead of the trends.",
  "Integrity and Transparency: We maintain an open and honest relationship with all our clients and partners.",
];

const services = [
  { title: "Raw Material Sourcing", icon: <Build /> },
  { title: "Fabric Printing", icon: <Palette /> },
  { title: "Pattern Design", icon: <DesignServices /> },
  { title: "Fabric Cutting", icon: <ContentCut /> },
  { title: "Stitching and Sewing", icon: <Checkroom /> },
  { title: "Tailor-Made Custom Designs", icon: <EmojiObjects /> },
  { title: "Quality Control", icon: <Verified /> },
  { title: "Labeling and Branding", icon: <Label /> },
  { title: "Ironing and Finishing", icon: <Iron /> },
  { title: "Packing and Warehousing", icon: <Warehouse /> },
  { title: "Design Consultancy", icon: <Work /> },
  { title: "Bulk Order Handling", icon: <Inventory /> },
  { title: "Custom Fabric Selection", icon: <TextileIcon /> },
];

const AboutPage = React.memo(() => {
  return (
    <div className="max-w-6xl mx-auto my-10 p-5 bg-white shadow-md rounded-lg mt-20">
      <h1 className="text-3xl font-bold text-center mb-6 text-gray-700">
        About Siddhi Creatives
      </h1>

      <div className="flex flex-col gap-5">
        <div className="text-center text-lg text-gray-700">
          At Siddhi Creatives, we are passionate about bringing the latest trends
          in ladies' fashion to life with a focus on quality, creativity, and customer
          satisfaction.
        </div>

        <h3 className="text-2xl font-semibold mt-10 text-gray-700">
          Our Core Values
        </h3>
        <ul className="list-disc list-inside text-gray-700">
          {coreValues.map((value, index) => (
            <li
              key={index}
              className="transition-transform transform"
            >
              {value}
            </li>
          ))}
        </ul>

        <h3 className="text-2xl font-semibold mt-10 text-gray-700">
          Our Services
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4">
          {services.map((service, index) => (
            <div
              key={index}
              className="flex flex-col items-center p-6 bg-gray-50 rounded-lg shadow-md transition-transform transform hover:scale-105 hover:shadow-lg"
            >
              <div className="text-gray-700 text-4xl mb-4">{service.icon}</div>
              <h4 className="text-lg font-semibold text-center text-gray-700">
                {service.title}
              </h4>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default AboutPage;
